// Dexie Unit of Work abstraction to centralize transactions

import { toRaw } from 'vue';
import type Dexie from 'dexie';
import { db } from '@/db/dexieClient';

export class UnitOfWork {
  private readonly dexie: Dexie;

  constructor(dexieInstance: Dexie) {
    this.dexie = dexieInstance;
  }

  async runRW<T>(tables: Dexie.Table<any, any>[], fn: () => Promise<T>): Promise<T> {
    return this.dexie.transaction('rw', tables, fn);
  }

  /**
   * Converts Vue reactive Proxy objects to plain JavaScript objects.
   * This is necessary before saving to IndexedDB, which cannot clone Proxy objects.
   * @param value - The value to convert (can be an object, array, or primitive)
   * @returns A plain JavaScript object/array/value
   */
  static toPlain<T>(value: T): T {
    return toRaw(value);
  }
}

export const uow = new UnitOfWork(db);
